import { login, logout, getInfo } from '@/api/user'
import { 
	getToken, setToken, 
	removeToken, 
	setLanguage, getLanguage, 
	getConfig
} from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { getCookie, setCookie, delCookie } from '@/utils/cookiejs'

const state = {
	token: getCookie("token"),
	name: '',
	avatar: '',
	introduction: '',
	roles: [],
	config: getConfig(),	// 系统配置
	language: getLanguage(),	// 多语言
	loginDialogVisible: false,			// 登錄彈框
	startedDialogVisible: false,		// 註冊彈框
	createSuccessVisible: false,		// 创建成功弹框
	chatDialogVisible: false
}

const mutations = {
	SET_SOCKET: (state, socket) => {
		state.socket = socket
	},
	SET_TOKEN: (state, token) => {
		state.token = token
		if (!token) {
			delCookie('token')
		}
		else {
			setCookie('token', token)
		}
	},
	SET_INTRODUCTION: (state, introduction) => {
		state.introduction = introduction
	},
	SET_NAME: (state, name) => {
		state.name = name
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_ROLES: (state, roles) => {
		state.roles = roles
		if (!roles || roles.length <= 0) {
			delCookie('role')
		}
		else {
			setCookie('role', roles)
		}
	},
	SET_LANGUAGE: (state, lang) => {
		state.language = lang
		setLanguage(lang)
	},
	DIALOG_VISIBLE: (state, visibility) => {
		state.loginDialogVisible = visibility
	},
	STARTED_VISIBLE: (state, visibility) => {
		state.startedDialogVisible = visibility
	},
	SUCCESS_VISIBLE: (state, visibility) => {
		state.createSuccessVisible = visibility
	},
	CHAT_VISIBLE: (state, visibility) => {
		state.chatDialogVisible = visibility
	}
}

const actions = {
	// user login
	login({ commit }, userInfo) {
		const {
			username,
			password
		} = userInfo
		return new Promise((resolve, reject) => {
			login({
				username: username.trim(),
				password: password
			}).then(res => {
				const { data } = res
				commit('SET_TOKEN', data.token)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// get user info
	getInfo({ commit, state }) {
		return new Promise((resolve, reject) => {
			getInfo(state.token).then(res => {
				const { data } = res

				if (!data) {
					reject('Verification failed, please Login again.')
				}

				const { roles, name, avatar, introduction } = data

				// roles must be a non-empty array
				if (!roles || roles.length <= 0) {
					reject('getInfo: roles must be a non-null array!')
				}

				commit('SET_ROLES', roles)
				commit('SET_NAME', name)
				commit('SET_AVATAR', avatar)
				commit('SET_INTRODUCTION', introduction)
				resolve(data)
			}).catch(error => {
				reject(error)
			})
		})
	},

	// user logout
	logout({ commit, state, dispatch }) {
		return new Promise((resolve, reject) => {
			logout(state.token).then(() => {
				commit('SET_TOKEN', '')
				commit('SET_ROLES', [])
				resetRouter()
				// reset visited views and cached views
				// to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
				dispatch('tagsView/delAllViews', null, {
					root: true
				})

				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// remove token
	resetToken({ commit }) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '')
			commit('SET_ROLES', [])
			resolve()
		})
	},
	
	// Set up multiple languages
	setLanguage({ commit }, language){
		commit('SET_LANGUAGE', language)
	},

	// 动态修改权限
	async changeRoles({ commit, dispatch }, role) {
		commit('SET_ROLES', role)

		const { roles } = await dispatch('getInfo')
		resetRouter()

		// generate accessible routes map based on roles
		const accessRoutes = await dispatch('permission/generateRoutes', roles, {
			root: true
		})
		// dynamically add accessible routes
		router.addRoutes(accessRoutes)

		// reset visited views and cached views
		dispatch('tagsView/delAllViews', null, {
			root: true
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}